module.exports = __webpack_public_path__ + "media/images/icon__twitter-5e590fa41196a49477818aabd20e704d.png";